(function () {
  "use strict";

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var drawer = qs("#cart-drawer");
  var drawerBody = qs("#cart-drawer-body");
  var bagCount = qs("#bagCount");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (bagCount) bagCount.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  // Mirrors the real UK shipping rate: free on orders of £20+ (after discounts), £3.99 below.
  var FREE_DELIVERY_THRESHOLD_PENCE = 2000;

  function renderDrawerFromCart(cart) {
    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="cart-drawer-empty"><p>Your bag is empty.</p><a class="btn btn-line dark" href="/collections/all">Start shopping</a></div>';
      return;
    }
    var shipRemaining = Math.max(0, FREE_DELIVERY_THRESHOLD_PENCE - cart.total_price);
    var shipPct = Math.min(100, Math.round((cart.total_price / FREE_DELIVERY_THRESHOLD_PENCE) * 100));
    var shippingHtml = shipRemaining > 0
      ? '<div class="cdf-shipping"><p class="cdf-shipping-msg">Spend <strong>' +
        formatMoney(shipRemaining) +
        '</strong> more for free UK delivery</p><div class="cdf-progress"><div class="cdf-progress-bar" style="width:' +
        shipPct +
        '%;"></div></div></div>'
      : '<div class="cdf-shipping"><p class="cdf-shipping-msg cdf-shipping-msg--done"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Your order qualifies for free UK delivery</p><div class="cdf-progress"><div class="cdf-progress-bar" style="width:100%;"></div></div></div>';
    var itemsHtml = cart.items
      .map(function (item, idx) {
        var img = item.image ? '<img src="' + item.image + '&width=160" alt="">' : "";
        var variant =
          item.variant_title && item.variant_title !== "Default Title"
            ? '<span class="cdi-variant">' + item.variant_title + "</span>"
            : "";
        return (
          '<div class="cart-drawer-item" data-line="' +
          (idx + 1) +
          '"><a href="' +
          item.url +
          '" class="cart-drawer-item-img">' +
          img +
          '</a><div class="cart-drawer-item-info"><a href="' +
          item.url +
          '">' +
          item.product_title +
          "</a>" +
          variant +
          '<div class="cdi-row"><span class="cdi-price">' +
          formatMoney(item.final_line_price) +
          '</span></div><div class="cdi-controls"><div class="cdi-stepper"><button type="button" class="cdi-step-btn" data-cart-qty-decrease="' +
          (idx + 1) +
          '" aria-label="Decrease quantity">−</button><span class="cdi-qty-value" data-qty="' +
          item.quantity +
          '">' +
          item.quantity +
          '</span><button type="button" class="cdi-step-btn" data-cart-qty-increase="' +
          (idx + 1) +
          '" aria-label="Increase quantity">+</button></div><button type="button" class="cdi-remove-btn" data-cart-remove="' +
          (idx + 1) +
          '" aria-label="Remove item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg></button></div></div></div>'
        );
      })
      .join("");
    drawerBody.innerHTML =
      shippingHtml +
      '<div class="cart-drawer-items">' +
      itemsHtml +
      '</div><div class="cart-drawer-foot"><div class="cdf-subtotal"><span>Subtotal</span><span>' +
      formatMoney(cart.total_price) +
      '</span></div><p class="cdf-note">10% off 3+ items applied automatically</p><a class="btn btn-primary" style="width:100%;text-align:center;" href="/cart">View bag</a><a class="btn btn-line dark" style="width:100%;text-align:center;margin-top:10px;" href="/cart?checkout">Checkout</a></div>';
  }

  function removeFromCart(line) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: 0 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (bagCount) bagCount.textContent = cart.item_count;
        renderDrawerFromCart(cart);
      })
      .catch(function () {});
  }

  function updateCartQuantity(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (bagCount) bagCount.textContent = cart.item_count;
        renderDrawerFromCart(cart);
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return "£" + (cents / 100).toFixed(2);
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return fetch("/cart.js");
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (bagCount) bagCount.textContent = cart.item_count;
        renderDrawerFromCart(cart);
        openDrawer();
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-cart-open]");
    if (opener) {
      e.preventDefault();
      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderDrawerFromCart(cart);
          openDrawer();
        });
      return;
    }
    var closer = e.target.closest("[data-cart-close]");
    if (closer) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var remover = e.target.closest("[data-cart-remove]");
    if (remover) {
      e.preventDefault();
      var line = remover.getAttribute("data-cart-remove");
      remover.disabled = true;
      removeFromCart(parseInt(line, 10));
      return;
    }
    var qtyIncrease = e.target.closest("[data-cart-qty-increase]");
    if (qtyIncrease) {
      e.preventDefault();
      var incLine = qtyIncrease.getAttribute("data-cart-qty-increase");
      var incRow = qtyIncrease.closest(".cart-drawer-item");
      var incValue = incRow ? incRow.querySelector(".cdi-qty-value") : null;
      var incQty = incValue ? parseInt(incValue.getAttribute("data-qty"), 10) : 1;
      qtyIncrease.disabled = true;
      updateCartQuantity(parseInt(incLine, 10), incQty + 1);
      return;
    }
    var qtyDecrease = e.target.closest("[data-cart-qty-decrease]");
    if (qtyDecrease) {
      e.preventDefault();
      var decLine = qtyDecrease.getAttribute("data-cart-qty-decrease");
      var decRow = qtyDecrease.closest(".cart-drawer-item");
      var decValue = decRow ? decRow.querySelector(".cdi-qty-value") : null;
      var decQty = decValue ? parseInt(decValue.getAttribute("data-qty"), 10) : 1;
      qtyDecrease.disabled = true;
      updateCartQuantity(parseInt(decLine, 10), Math.max(0, decQty - 1));
      return;
    }
    var addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute("data-add-to-cart");
      var original = addBtn.textContent;
      addBtn.textContent = "Adding…";
      addBtn.disabled = true;
      addToCart(variantId).then(function () {
        addBtn.textContent = original;
        addBtn.disabled = false;
      });
      return;
    }
  });

  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (form) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      addToCart(idInput ? idInput.value : null);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  // Header goes from transparent (over the homepage hero) to solid once the
  // page is scrolled past the hero. On pages without a hero, the header CSS
  // defaults to solid already, so this is only visually relevant on the home page.
  var siteHeader = qs("#siteHeader");
  if (siteHeader) {
    var scrollThreshold = 60;
    function updateHeaderScrollState() {
      if (window.scrollY > scrollThreshold) {
        siteHeader.classList.add("is-scrolled");
      } else {
        siteHeader.classList.remove("is-scrolled");
      }
    }
    updateHeaderScrollState();
    window.addEventListener("scroll", updateHeaderScrollState, { passive: true });
  }

  updateCartCount();
})();
